import React from 'react'
import { Empty } from 'antd'
import OrderTable from './OrderTable'
import './index.less'

interface OrderCardProps {
  dataSource?: SwaggerDTO.我的订单分页查询订单返回对象[]
  receiptHandle?: Function
}

export default function OrderCard({
  dataSource,
  receiptHandle,
}: OrderCardProps) {
  return (
    <div className="order-card">
      <table className="order-tb">
        <colgroup>
          <col className="number-col" />
          <col className="amount-col" />
          <col className="consignee-col" />
          <col className="status-col" />
          <col className="options-col" />
        </colgroup>
        <thead>
          <tr>
            <th className="order-t">订单详情</th>
            <th>金额</th>
            <th>收货人</th>
            <th className="order-status">订单状态</th>
            <th className="order-options">操作</th>
          </tr>
        </thead>
        {dataSource?.map(item => (
          <OrderTable key={item.id} data={item} receiptHandle={receiptHandle} />
        ))}
      </table>
      {!dataSource?.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </div>
  )
}
